export default "__VITE_PUBLIC_ASSET__36109d2a__"